import { render, staticRenderFns } from "./page-container.vue?vue&type=template&id=6d76697a"
var script = {}
import style0 from "./page-container.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports